import { LitElement, html, css,} from 'lit';
import {msg} from '@lit/localize';

export class AllInAddress extends LitElement {
    static properties = {
        address1: { type: String },
        address2: { type: String },
        city: { type: String },
        homeCountry: { type: String },
        country: { type: String },
        postcode: { type: String },
        required: { type: Boolean},
        errorMessage: { type: String },
        noNation: {type: Boolean},
    }

    updated(changedProperties) {
        if(window.pca&&!this.control) {
            this.control.load();
        }
    }

    firstUpdated(changedProperties) {
        if(window.pca&&!this.control) {

            let fields = [
                {element:'address1',field:"Line1"},
                {element:'address2',field:"Line2"},
                {element:'city',field:"City"},
                {element:'country',field:"Country",mode:pca.fieldMode.COUNTRY | pca.fieldMode.PRESERVE},
                {element:'postcode',field:"PostalCode"},
            ];
            this.control = new pca.Address(fields,{key:import.meta.env.VITE_LOQATE_KEY});
        }
    }

    createRenderRoot() { 
        return this;
    }
    
 
    render() {
        return html`
        <div class="address_form_container">
            <link rel="stylesheet" type="text/css" href="https://api.addressy.com/css/address-3.99.css" />
            <div class="input-group">
                <label for="address1">${msg(`Street Address`)}*</label>
                <input type="text" id="address1" name="address1" value="${this.address1}" aria-required="${this.required}" data-error_message="${this.errorMessage }">
            </div>
            <div class="input-group">
                <label for="address2">${msg(`Address Line 2`)}</label>
                <input type="text" id="address2" name="address2" value="${this.address2}">
            </div>
            <div class="input-group">
                <label for="city">${msg(`City`)}*</label>
                <input type="text" id="city" name="city" value="${this.city}" aria-required="${this.required}" data-error_message="${this.errorMessage}" >
            </div>
            ${!this.noNation?html`
            <div class="input-group">
                    <label for="homeCountry">${msg(`Nation`)}*</label>
                    <select id="homeCountry" name="homeCountry" value="${this.homeCountry}" aria-required="${this.required}" data-error_message="${this.errorMessage}">
                        <option value="">${msg(`Select a nation`)}</option>
                        <option value="England" ?selected=${this.homeCountry === 'England'}>${msg(`England`)}</option>
                        <option value="Scotland" ?selected=${this.homeCountry === 'Scotland'}>${msg(`Scotland`)}</option>
                        <option value="Wales" ?selected=${this.homeCountry === 'Wales'}>${msg(`Wales`)}</option>
                        <option value="NorthernIreland" ?selected=${this.homeCountry === 'Northern Ireland'}>${msg(`Northern Ireland`)}</option>
                        <option value="Ireland" ?selected=${this.homeCountry === 'Ireland'}>${msg(`Ireland`)}</option>
                    </select>
                </div>
            `:html``}
            <div class="input-group">
                <label for="country">${msg(`Country`)}*</label>
                <input type="text" id="country" name="country" value="${this.country}" aria-required="${this.required}" data-error_message="${this.errorMessage}" >
            </div>
            <div class="input-group">
                <label for="postcode">${msg(`Postcode`)}*</label>
                <input type="text" id="postcode" name="postcode" value="${this.postcode}" aria-required="${this.required}" data-error_message="${this.errorMessage}" >
            </div>
        </div>
        `;
    }
/*   */

  static styles = [
    css`
        :host {
            font-family:var(--allin-font-family,inherit);
            font-size:var(--allin-font-size,1rem);
            color:var(--allin-text-color,#000);
            background-color:var(--allin-bg-color,transparent);
            padding:var(--allin-padding,0);
            font-weight: var(--allin-font-weight, normal);
        }
    `];
}


